import React, { useState } from 'react'

type ContactBarProps = {
  prompt: string
  namePlaceholder: string
  phonePlaceholder: string
  saveLabel: string
  facebookLabel?: string
  /** Keep the Facebook button in the DOM but visually hidden (display:none). */
  facebookHidden?: boolean
  onSubmit: (payload: { name: string; contact: string }) => void
  onFacebook?: () => void
}

// Slim name + phone capture above the composer. Calls onSubmit (-> identify),
// then the parent hides it.
export const ContactBar: React.FC<ContactBarProps> = ({
  prompt,
  namePlaceholder,
  phonePlaceholder,
  saveLabel,
  facebookLabel,
  facebookHidden,
  onSubmit,
  onFacebook,
}) => {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const canSave = name.trim().length > 0 && phone.trim().length > 0

  const submit = () => {
    if (!canSave) return
    onSubmit({ name: name.trim(), contact: phone.trim() })
  }

  return (
    <div className="wc-contact">
      <span className="wc-contact-prompt">{prompt}</span>
      <div className="wc-contact-row">
        <input
          className="wc-contact-input"
          type="text"
          value={name}
          placeholder={namePlaceholder}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), submit())}
        />
        <input
          className="wc-contact-input"
          type="tel"
          value={phone}
          placeholder={phonePlaceholder}
          onChange={(e) => setPhone(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), submit())}
        />
        <button
          type="button"
          className="wc-contact-save"
          disabled={!canSave}
          onClick={submit}
        >
          {saveLabel}
        </button>
      </div>
      {facebookLabel && onFacebook && (
        <button
          type="button"
          className={
            facebookHidden
              ? 'wc-contact-facebook wc-contact-facebook--hidden'
              : 'wc-contact-facebook'
          }
          onClick={onFacebook}
        >
          {facebookLabel}
        </button>
      )}
    </div>
  )
}

type PhoneBarProps = {
  prompt: string
  phonePlaceholder: string
  saveLabel: string
  onSubmit: (phone: string) => void
}

// Phone-only capture shown after a Facebook login: Facebook gives us the name
// and email but never a phone, and the operator needs a callable contact.
export const PhoneBar: React.FC<PhoneBarProps> = ({
  prompt,
  phonePlaceholder,
  saveLabel,
  onSubmit,
}) => {
  const [phone, setPhone] = useState('')
  const canSave = phone.trim().length > 0

  const submit = () => {
    if (!canSave) return
    onSubmit(phone.trim())
  }

  return (
    <div className="wc-contact">
      <span className="wc-contact-prompt">{prompt}</span>
      <div className="wc-contact-row">
        <input
          className="wc-contact-input"
          type="tel"
          value={phone}
          placeholder={phonePlaceholder}
          onChange={(e) => setPhone(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), submit())}
        />
        <button
          type="button"
          className="wc-contact-save"
          disabled={!canSave}
          onClick={submit}
        >
          {saveLabel}
        </button>
      </div>
    </div>
  )
}
